
import styled from "styled-components";
import { Col } from 'antd'

export const Box = styled.div`
  background-color: rgba(0, 103, 120, 0.15);
  position: relative;
  padding : 20px 20px !important;
  text-align:center;
  box-shadow: 0px 10px 10px rgba(225, 225, 225, 0.5); 
  animation: slide-up 1s ease; 
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(-20px);
  }
  100% {
      opacity: 1;
      transform: translateY(0);
  }
}

@media (max-width: 991px) {
  margin-top : 30px;
  padding: 20px 20px !important;

  &:before {
    top: -20px;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: rgba(0, 103, 120, 0.15);
    border-width: 10px;
    margin-left: -10px;
  }
}

`;

export const BottomWrapper = styled.div`
  padding-top:20px
  display : flex;
  justify-content: space-between;
`;

export const FilterCol = styled(Col)`
  padding-bottom: 1.5625rem;
  max-height: 6.25rem;
  @media (max-width: 991px) {
    padding:10px 10px;
  }
`;

export const CloseText = styled.button`
  font-size: ${props => props.theme.fontSize.primary};
  background: none;
  border: none;
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  svg {
    font-size: ${props => props.theme.fontSize.quaternary};
  }
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const PoweredBy = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.quaternary};
  color: ${props => props.theme.fontColors.textColor};
  align-items: center;
  span {
    margin-right :10px;
    font-size: font-size: ${props => props.theme.fontSize.quaternary};
  }
`;
